import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgInfoDimension = {
  height: 24,
  width: 24,
  viewBox: '0 0 24 24',
};
export const SvgInfo = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M12 2.5C17.2439 2.5 21.5 6.75614 21.5 12C21.5 17.2439 17.2439 21.5 12 21.5C6.75614 21.5 2.5 17.2439 2.5 12C2.5 6.75614 6.75614 2.5 12 2.5ZM12 3.5C7.31386 3.5 3.5 7.31386 3.5 12C3.5 16.6861 7.31386 20.5 12 20.5C16.6861 20.5 20.5 16.6861 20.5 12C20.5 7.31386 16.6861 3.5 12 3.5ZM12.5 11.5V16.5H11.5V11.5H12.5ZM12.5 7.5V8.5H11.5V7.5H12.5Z"
      stroke="currentColor"
    />
  </svg>
));
